import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import ReelsList from '../../components/inventory/Reels/ReelsList';
import ReelsHeader from '../../components/inventory/Reels/ReelsHeader';
import ReelsFilter from '../../components/inventory/Reels/ReelsFilter';

import { useSessionContext } from '../../contexts/SessionContext';

export default function InventoryReelsPage( props ){
    console.debug("RTS Break InventoryReelsPage");

    const {curFilter, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);
    
    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Reels/GetReelsSummary";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'ReelsPage'){
            setFilter(curFilter.filter);
        }
        else{
            setFilter({reelType:null, status:1});
        }
    }, [props, curFilter]); 


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'ReelsPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({reelType:null, status:1});
            fetchData({reelType:null, status:1})
        }
    }, [props, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
        <Box>
            <ReelsHeader />
            <ReelsFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <ReelsList data={data} />
            </Box>
        </Box>
        </>
    );
}
